const InvoiceType = `
  id
  description
`;

export default InvoiceType;
